/*
 * rheincool — Akkordeon (Komponenten-Katalog 4.5)
 * <rc-accordion> mit [data-accordion-toggle] + [data-accordion-panel]:
 * aria-expanded, Enter/Space (native button), Chevron dreht via CSS.
 * Mehrere Toggle/Panel-Paare pro Element möglich (FAQ-Listen).
 */
class RcAccordion extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-accordion-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!panel) return;
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.hidden = expanded;
        toggle.closest('[data-accordion-item]')?.classList.toggle('is-open', !expanded);
        if (!expanded && window.rcTrack && toggle.dataset.faqQuestion) {
          window.rcTrack('faq_open', { question: toggle.dataset.faqQuestion });
        }
      });
    });
  }
}

customElements.define('rc-accordion', RcAccordion);
